import React, { useState, useRef, useEffect, useCallback } from "react";
import List from "src/components/grid.component";
import { Button, Form, Modal, Alert, message, Input } from "antd";
import { connect, useSelector } from "react-redux";
import apiCalls from "src/api/apiCalls";
import { TemplateNameHandler } from "./service";
import GridLayout from "../shared/gridLayout";
import ActionsComponent from "../shared/ActionsComponent";
const { TextArea } = Input;
const TemplateDetails = (props) => {
  const gridRef = useRef(null);
  const user = useSelector(state => state.oidc?.user.currentUser)
  const apiurl = `${process.env.REACT_APP_GRID_API}api/CaseManagement/CaseTemplates`
  const [state, setState] = useState({
    selectedObj: null,
    addModalShow: false,
    loading: false,
    btnLoader: false,
    isRefresh: false,
    deleteCaseTemplateModal: false,
    selection: [],
    selectedItem: null,
    errorMessage: '',
    modalError: null
  });
  const [form] = Form.useForm();
  const formRef = useRef();
  const inputCheckBoxHandle = useCallback((prop) => {
    setState((prev) => ({
      ...prev,
      errorMessage: null,
    }));
    const rowChecked = prop?.dataItem;
    let _selection = [...state.selection];
    let idx = _selection.indexOf(rowChecked?.id);
    if (idx > -1) {
      _selection.splice(idx, 1);
    } else {
      _selection.push(rowChecked?.id);
    }
    setState((prev) => ({
      ...prev,
      selectedItem: _selection.includes(rowChecked?.id) ? rowChecked : null,
      selection: _selection,
    }));
    if (rowChecked) {
      form.setFieldsValue({ status: rowChecked?.whiteListStatus });
    }
  }, [state.selection, form]);
  const handleAddTemplate = () => {
    setState((prev) => ({ ...prev, addModalShow: true, selectedItem: "", errorMessage: null }));
  };
  const handleEditModel = useCallback((data) => () => {
    if (data?.id !== `00000000-0000-0000-0000-000000000000`) {
      setState((prev) => ({
        ...prev,
        addModalShow: true,
        selectedItem: data,
        errorMessage: null
      }));
      form.setFieldsValue(data);
    }
  }, [form])
  const handleEditTemplate = () => {
    if (state.selection?.length === 0) {
      setState((prev) => ({ ...prev, errorMessage: "Please select one record" }));
      return;
    }
    setState((prev) => ({ ...prev, addModalShow: true }));
  };
  const handleDeleteTemplate = () => {
    if (state.selection?.length === 0) {
      setState((prev) => ({ ...prev, errorMessage: "Please select one record" }));
      return;
    }
    setState((prev) => ({ ...prev, deleteCaseTemplateModal: true }));
  };
  const handleCancel = useCallback(() => {
    setState((prev) => ({ ...prev, addModalShow: false, deleteCaseTemplateModal: false, selection: [], }));
    form.resetFields();
  }, [form, props]);
  const saveCaseTemplate = useCallback(async (value) => {
    setState((prev) => ({ ...prev, btnLoader: true }));
    try {
      const obj = {
        id: state?.selectedItem?.id || "00000000-0000-0000-0000-000000000000",
        templateName: value.templateName,
        remarks: value.remarks,
        createdBy: user.userName,
        createddate: new Date(),
        modifiedBy: user.userName,
        modifiedDate: new Date(),
        info: "",
      };
      const res = await apiCalls.saveTemplate(obj);
      if (res.ok) {
        setState((prev) => ({
          ...prev,
          addModalShow: false,
          isRefresh: true,
          btnLoader: false,
          selection: [],
          selectedItem: null,
        }));
        message.success({
          content: "Template details saved successfully",
          className: "custom-msg",
          duration: 3,
        });
        gridRef?.current?.refreshGrid();
      } else {
        setState((prev) => ({ ...prev, modalError: "Error saving template", btnLoader: false }));
      }
    } catch (error) {
      setState((prev) => ({
        ...prev,
        errorMessage: apiCalls.isErrorDispaly(error),
        btnLoader: false,
      }));
      form.resetFields();
    }
  }, [state?.selectedItem, user?.userName, apiCalls, props, gridRef, form]);
  const confirmDeleteTemplate = useCallback(async () => {
    try {
      setState((prev) => ({ ...prev, loading: true }));
      const res = await apiCalls.deleteCaseTemplate(state?.selection?.[0]);
      if (res.ok) {
        setState((prev) => ({
          ...prev,
          loading: false,
          deleteCaseTemplateModal: false,
          isRefresh: true,
          btnLoader: false,
          selection: [],
          selectedItem: null,
        }));
        message.success({
          content: "Template deleted successfully",
          className: "custom-msg",
          duration: 3,
        });
        gridRef?.current?.refreshGrid();
      } else {
        setState((prev) => ({ ...prev, modalError: apiCalls.isErrorDispaly(res), btnLoader: false }));
      }
    } catch (error) {
      setState((prev) => ({
        ...prev,
        loading: false,
        isRefresh: true,
        btnLoader: false,
        selection: [],
      }));
      form.resetFields();
    }
  }, [state?.selection, apiCalls, props, gridRef, form]);
  useEffect(() => {
    if (props?.action)
      onActionClick(props?.action);
  }, [props?.action])
  const onActionClick = useCallback((action) => {
    switch (action) {
      case "add":
        handleAddTemplate();
        break;
      case "edit":
        handleEditTemplate();
        break;
      case "delete":
        handleDeleteTemplate();
        break;
      default:
        break;
    }
  },[]);
  const templateNameHandler = useCallback((props) => {
    return <TemplateNameHandler data={props?.dataItem} handleEditModel={handleEditModel} />
  }, [])
  const customcells = {
    "templateName": templateNameHandler
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  const refreshCallBack = useCallback(() => {
    setState((prevState) => ({ ...prevState, isRefresh: false }));
  }, []);
  return (
    <div className="cases-template">
      <div>
        {state?.errorMessage && <Alert className="mb-4 w-100" type="error" description={state?.errorMessage} showIcon closable />}
      </div>
      <Modal className="custom-template-modal" title={`${state?.selectedItem?.id ? "Edit Template" : "Add Template"}`} visible={state.addModalShow} onCancel={handleCancel} footer={null} destroyOnClose>
        {state?.modalError && <Alert className="mb-4 w-100" type="error" description={state?.modalError} showIcon closable />}
        {state.loading && <div>Loading...</div>}
        <Form ref={formRef} className="risk-popup custom-user-input" onFinish={saveCaseTemplate} initialValues={state.selectedItem}>
          <Form.Item name="templateName" className="custom-input !mb-3" rules={[{ required: true, message: " Is required " }]} label="Template Name">
            <Input placeholder="Template Name" maxLength={50} />
          </Form.Item>
          <Form.Item name="remarks" className="custom-input" rules={[{ required: true, message: " Is required " }]} label="Remarks">
            <TextArea placeholder="Remarks" maxLength={500} showCount={200} rows={4} className="bg-transparent" />
          </Form.Item>
          <Form.Item >
            <div className="!mt-8 md:flex justify-end gap-2 space-y-2 md:space-y-0 modal-group-btn">
              <Button className="cancel-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button type="primary" className="primary-btn" htmlType="submit" loading={state.btnLoader}>
                Save
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <Modal visible={state.deleteCaseTemplateModal} title={"Confirm Delete"} onCancel={handleCancel} footer={null}>
        <p>Are you sure, do you really want to Delete?</p>
        <div className="mt-5 md:flex justify-end gap-2 space-y-2 md:space-y-0">
          <Button type="default" className="cancel-btn" onClick={handleCancel}>
            No
          </Button>
          <Button type="primary" className="primary-btn" onClick={confirmDeleteTemplate} loading={state?.loading}>
            Yes
          </Button>
        </div>
      </Modal>
      <div className='flex justify-end gap-2 mb-3'>
        <ActionsComponent serviceName={"CardsManageService.Cases"} onActionClick={onActionClick} targetTabName="Templates" />
        <GridLayout />
      </div>
      <List
        url={apiurl}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        screenName={'Cases_Templates'}
        renderCustomCell={renderCustomCell}
        handleSelection={inputCheckBoxHandle}
        showGridSelection={true}
        selection={[state?.selectedItem?.id]}
        refresh={state.isRefresh}
        refreshCallBack={refreshCallBack}
      />
    </div>
  );
};
const connectStateToProps = ({ oidc }) => {
  return {
    userConfig: oidc?.user,
  };
};
export default connect(connectStateToProps)(TemplateDetails);
